var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14_806)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9288 15.5267V18.2751C20.9299 18.5302 20.8762 18.7828 20.7714 19.0166C20.6665 19.2504 20.5127 19.4602 20.3198 19.6327C20.1269 19.8052 19.8991 19.9365 19.6512 20.0182C19.4032 20.1 19.1404 20.1303 18.8797 20.1074C15.9873 19.8011 13.2089 18.8377 10.7678 17.2948C8.49673 15.8883 6.57124 14.0116 5.12808 11.798C3.53953 9.40804 2.55094 6.68693 2.2424 3.85517C2.21892 3.60183 2.24981 3.3465 2.33311 3.10543C2.41642 2.86436 2.55031 2.64284 2.72626 2.45497C2.90222 2.2671 3.11638 2.117 3.35512 2.01422C3.59386 1.91144 3.85194 1.85824 4.11292 1.858H6.9328C7.38897 1.85362 7.83121 2.01107 8.17709 2.30098C8.52296 2.59089 8.74888 2.9935 8.81272 3.43375C8.93174 4.3133 9.15247 5.1769 9.4707 6.00808C9.59716 6.33599 9.62453 6.69236 9.54956 7.03496C9.4746 7.37756 9.30043 7.69204 9.04771 7.94112L7.85396 9.10461C9.19205 11.3982 11.1405 13.2972 13.4937 14.6014L14.6875 13.4379C14.943 13.1916 15.2657 13.0219 15.6172 12.9488C15.9687 12.8757 16.3344 12.9024 16.6708 13.0257C17.5236 13.3358 18.4096 13.551 19.3121 13.667C19.7687 13.7297 20.1857 13.9539 20.4838 14.2968C20.7819 14.6397 20.9402 15.0774 20.9288 15.5267Z",
    stroke: "white",
    strokeWidth: 1.87992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14_806"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.559,
    height: 21.9872,
    fill: "white",
    transform: "translate(0.249689 0.0256348)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.d35472e1644ebd435c867c75fb3f49f9.svg";
export { ForwardRef as ReactComponent };